import * as Yup from "yup";


export const PathologySchema = Yup.object({
    company_name: Yup.string().required(" Enter Pathology Name"),
    phone_no: Yup.string().min(10, 'Must be exactly 10 digits').required("Enter Mobile Number").matches(/^(((0|((\+)?91(\-)?))|((\((\+)?91\)(\-)?)))?[6-9]\d{9})?$/, "Invalid Number"),
    designation: Yup.string().required(" Select Designation"),
    department: Yup.string().required("Select Department"),
    contact_person: Yup.string().required('Enter Contact Person'),
    cust_code: Yup.string().required("Enter Unique Short Code"),
    email_id: Yup.string().required(" Enter Email"),
    password: Yup.string().required(" Enter  Password"),
    cust_logo: Yup.mixed().required('Image is required'),
    city: Yup.string().required("Select City"),
    status: Yup.string().required(" Select Status"),
});

export const UpdatePathologySchema = Yup.object({
    company_name: Yup.string().required(" Enter Pathology Name"),
    phone_no: Yup.string().min(10, 'Must be exactly 10 digits').required("Enter Mobile Number").matches(/^(((0|((\+)?91(\-)?))|((\((\+)?91\)(\-)?)))?[6-9]\d{9})?$/, "Invalid Number"),
    designation: Yup.string().required(" Select Designation"),
    department: Yup.string().required("Select Department"),
    contact_person: Yup.string().required('Enter Contact Person'),
    // cust_code: Yup.string().required("Enter Unique Short Code"),
    email_id: Yup.string().required(" Enter Email"),
    cust_logo: Yup.mixed().required('Image is required'),
    city: Yup.string().required("Select City"),
    status: Yup.string().required(" Select Status"),
});